<jzp-nav-bar [drawer]="drawer" [logoutFn]="logout" />
<mat-sidenav-container>
  <mat-sidenav id="side-nav" #drawer mode="over" position="end">
    <div id="button-container-column">
      <button
        color="primary"
        mat-flat-button
        routerLink="/home"
        routerLinkActive="active"
        extended
        (click)="drawer.toggle()"
      >
        <mat-icon>house</mat-icon>
        Home
      </button>
      <div class="vert-spacer"></div>
      <button
        color="primary"
        mat-flat-button
        routerLink="/blog"
        routerLinkActive="active"
        extended
        (click)="drawer.toggle()"
      >
        <mat-icon>person</mat-icon>
        Blog
      </button>
      <div class="vert-spacer"></div>
      <button
        color="primary"
        mat-flat-button
        routerLink="/hobbies"
        routerLinkActive="active"
        extended
        (click)="drawer.toggle()"
      >
        <mat-icon>sports_handball</mat-icon>
        Hobbies
      </button>
      <div class="vert-spacer"></div>
      <!-- <button
        color="primary"
        mat-flat-button
        routerLink="/news"
        routerLinkActive="active"
        extended
        (click)="drawer.toggle()"
      >
        <mat-icon>newspaper</mat-icon>
        <p>News</p>
      </button> -->
      <!-- <div class="vert-spacer"></div> -->
      <!-- <button
        color="primary"
        mat-flat-button
        routerLink="/socials"
        routerLinkActive="active"
        extended
        (click)="drawer.toggle()"
      >
        <mat-icon>groups</mat-icon>
        <p>Socials</p>
      </button>
      <div class="vert-spacer"></div> -->
      <button
        color="primary"
        mat-flat-button
        routerLink="/contact"
        routerLinkActive="active"
        (click)="drawer.toggle()"
      >
        <mat-icon>contact_mail</mat-icon>
        Contact Me
      </button>
      <div class="vert-spacer"></div>
      <div class="vert-spacer"></div>
      <button
        mat-flat-button
        color="warn"
        (click)="logout()"
        extended
        (click)="drawer.toggle()"
      >
        <mat-icon>logout</mat-icon>
        LOGOUT!
      </button>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div id="main-view">
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<jzp-footer id="footer-sidenav" />
